import React from "react";
import { AdditionalViewField } from "../shared/types";
import { DetailRows } from "../workspace/ReviewDetails";

// ----------------------------  DetailPreview  ----------------------------
// Live preview of the Additional View tab: when the view shows (its flag columns)
// and its rows as the auditor sees them, each value standing in for the column it
// is read from.

interface DetailPreviewProps {
  details: AdditionalViewField[];
  enableFlags: string[];
}

const columnsText = (d: AdditionalViewField): string =>
  d.source_columns
    .map((c) => c.trim())
    .filter(Boolean)
    .join(" / ");

const DetailPreview: React.FC<DetailPreviewProps> = ({ details, enableFlags }) => {
  const rows = [...details]
    .sort((a, b) => a.display_order - b.display_order)
    .map((d) => {
      const cols = columnsText(d);
      return { label: d.label.trim() || "(untitled row)", value: cols ? "Value of " + cols : "" };
    });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
      <div style={whenNote}>
        {enableFlags.length
          ? "Shown instead of the fields where " + enableFlags.join(" or ") + " is true."
          : "Pick a flag column: the view never shows without one."}
      </div>
      <div style={questionBanner}>Question (loaded from each record)</div>
      <DetailRows rows={rows} emptyText="Add rows to see a preview." />
    </div>
  );
};

// ----------------------------  Styles  ----------------------------

const whenNote: React.CSSProperties = { fontSize: "0.75rem", color: "#6b7280" };

const questionBanner: React.CSSProperties = {
  fontSize: "0.8rem",
  fontWeight: 600,
  color: "#6b7280",
  fontStyle: "italic",
  background: "#f0f7ff",
  borderRadius: "6px",
  padding: "8px 12px",
};

export default DetailPreview;
